<template>
  <v-row
    ><v-col cols="12" sm="6"
      ><h6>{{ $t("info_card.faculty_college") }}</h6>
      <v-text-field
        density="compact"
        v-model="faculty_name"
        :rules="rules"
      /> </v-col
    ><v-col cols="12" sm="6"
      ><h6>{{ $t("info_card.curriculum_name") }}</h6>
      <v-text-field
        density="compact"
        v-model="curriculum_name"
        :rules="rules"
      /> </v-col
  ></v-row>
</template>

<script>
import validator from "@/helper/validator";
export default {
  name: "FacultyCurriculum",
  props: {
    modelValue: Object,
  },
  data: () => ({
    rules: [validator.required],
  }),

  computed: {
    faculty_name: {
      get() {
        return this.modelValue.faculty_name;
      },
      set(value) {
        this.$emit("update:modelValue", {
          faculty_name: value,
          curriculum_name: this.curriculum_name,
        });
      },
    },

    curriculum_name: {
      get() {
        return this.modelValue.curriculum_name;
      },
      set(value) {
        this.$emit("update:modelValue", {
          faculty_name: this.faculty_name,
          curriculum_name: value,
        });
      },
    },
  },
};
</script>
